import React from 'react';
import styles from './Invoice.module.css';

function Invoice({
  billedTo,
  date,
  invoiceNo,
  items,
  subtotal,
  cgst,
  sgst,
  totalWithTax,
  paymentInfo,
  footerNote,
  contact,
  logoUrl,
  signatureUrl,
}) {
  const formatCurrency = (val) => {
    if (val === 0 || val === undefined || val === null) return '₹ 0';
    return `₹ ${Number(val).toLocaleString('en-IN')}`;
  };

  return (
    <div className={styles.invoice}>
      <div className={styles['invoice-header']}>
        <div className={styles['invoice-brand']}>
          {logoUrl && (
            <img
              src={logoUrl}
              alt="Company Logo"
              style={{ maxHeight: '55px', maxWidth: '120px', objectFit: 'contain' }}
            />
          )}
          <div>
            <h2>INVOICE</h2>
            <div className={styles.sub}>Tax Invoice</div>
          </div>
        </div>
        <div className={styles['invoice-meta']}>
          <div className={styles['invoice-no']}>
            <span>INVOICE NO.</span> {invoiceNo || '—'}
          </div>
          <div className={styles['date-text']}>
            <strong>DATE:</strong> {date || '—'}
          </div>
        </div>
      </div>

      <div className={styles['invoice-body']}>
        <div className={styles['invoice-billed']}>
          <div className={styles.label}>BILLED TO:</div>
          <div className={styles.value}>{billedTo || '—'}</div>
        </div>

        <div className={styles['invoice-table-wrap']}>
          <table className={styles['invoice-table']}>
            <thead>
              <tr>
                <th>DESCRIPTION</th>
                <th style={{ textAlign: 'center' }}>QUANTITY</th>
                <th style={{ textAlign: 'right' }}>PRICE</th>
                <th style={{ textAlign: 'right' }}>TOTAL</th>
              </tr>
            </thead>
            <tbody>
              {items.length === 0 ? (
                <tr className={styles['empty-row']}>
                  <td colSpan="4">No items added</td>
                </tr>
              ) : (
                items.map((item) => {
                  const total = (item.quantity || 0) * (item.price || 0);
                  return (
                    <tr key={item.id}>
                      <td>{item.description || '—'}</td>
                      <td style={{ textAlign: 'center' }}>{item.quantity || 0}</td>
                      <td style={{ textAlign: 'right' }}>{formatCurrency(item.price)}</td>
                      <td style={{ textAlign: 'right' }}>{formatCurrency(total)}</td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>

        <div className={styles['invoice-totals']}>
          <div className={styles['inv-total-line']}>
            <span>Subtotal:</span>
            <span className={styles.amount}>{formatCurrency(subtotal)}</span>
          </div>
          <div className={styles['inv-total-line']}>
            <span>CGST (2.5%):</span>
            <span className={styles.amount}>{formatCurrency(cgst)}</span>
          </div>
          <div className={styles['inv-total-line']}>
            <span>SGST (2.5%):</span>
            <span className={styles.amount}>{formatCurrency(sgst)}</span>
          </div>
          <div className={`${styles['inv-total-line']} ${styles.grand}`}>
            <span>Grand Total:</span>
            <span className={styles.amount}>{formatCurrency(totalWithTax)}</span>
          </div>
        </div>

        <div className={styles['invoice-signature']}>
          <div className={styles['sig-label']}>Authorised Signatory</div>
          {signatureUrl ? (
            <img src={signatureUrl} alt="Signature" className={styles['sig-image']} />
          ) : (
            <div style={{ fontSize: '13px', color: '#9bb1c4', fontStyle: 'italic' }}>— upload signature —</div>
          )}
          <div className={styles['sig-name']}>Akina Pavan Kalyan</div>
        </div>

        {paymentInfo && (
          <div className={styles['invoice-payment']}>
            <div className={styles['pay-label']}>PAYMENT INFORMATION</div>
            <div className={styles['pay-content']}>{paymentInfo}</div>
          </div>
        )}

        {footerNote && (
          <div className={styles['invoice-footer-note']}>{footerNote}</div>
        )}

        <div className={styles['invoice-footer']}>
          <div className={styles.thankyou}>THANK YOU FOR YOUR BUSINESS</div>
          <div className={styles.contact} style={{ whiteSpace: 'pre-line', lineHeight: '2.0' }}>
            {contact || '—'}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Invoice;